import { useNavigate } from 'react-router-dom'
import './HomePage.css'

export function HomePage() {
  const navigate = useNavigate()

  return (
    <div className="home-page">
      <div className="hero-section">
        <h1>3D模型预览应用</h1>
        <p>使用 Three.js 和 React Three Fiber 构建的3D模型展示平台</p>
        <button
          className="view-model-btn"
          onClick={() => navigate('/custom-deck-cover')}
        >
          查看模型
        </button>
      </div>
    </div>
  )
}